/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

import PropTypes from 'util/PropTypes';
import { TooltipPopup, Label, Flyout } from '@ba/ba-ui-carbon-toolkit';
import { ShapingAncestorTree } from 'ca-modeller/shaping';
import StringResources from '../../../nls/StringResources';
import './relationshipVisView.scss';

@observer
class RelationshipTooltip extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { model, shouldUseDisambiguatedPaths } = this.props;

		const tooltipInfo = model.getTooltipInfo();

		if (!tooltipInfo) {
			return null;
		}

		if (shouldUseDisambiguatedPaths && this._isTooltipForRGNode(tooltipInfo)) { // we keep old tooltips for relationship stregnths even w path disambiguation pending UX design
			return this._renderDisambiguatedTooltip(tooltipInfo);
		}
		return this._renderTooltip(tooltipInfo);
	}

	/* tooltipInfo structure:
	*	tooltipInfo = {
	*		title: [
	*			{
	*				label: '',
	*				value: ''
	*			}
	*		],
	*		coordinates: {
	*			top: Y,
	*			left: X,
	*			width: 0
	*		}
	*	};
	*/
	_renderTooltip(tooltipInfo) {
		const title = this._renderTitle(tooltipInfo);
		return (
			<TooltipPopup
				orient={'top'}
				title={title}
				triggerState={{
					top: tooltipInfo.coordinates.top,
					left: tooltipInfo.coordinates.left,
					width: tooltipInfo.coordinates.width
				}}
				delay={1500}
				style={{
					position:'fixed'
				}}
			/>
		);
	}

	_isTooltipForRGNode(tooltipInfo) {
		return tooltipInfo.title[0].label !== ''; //TODO: relationship strength parabola title's label is an empty string - need's better identifier
	}

	_renderTitle(tooltipInfo) {
		const items = tooltipInfo.title.map((text, index) => {
			let lineBreak;
			if (index < tooltipInfo.title.length - 1) {
				lineBreak = <br />;
			}
			const value = text.label + text.value;
			return (
				<div key={value}>
					<Label label={value} className="relationship-vis-view__tooltip__label" />
					{lineBreak}
				</div>
			);
		});

		return (
			<div className="relationship-vis-view__tooltip">
				{items}
			</div>
		);
	}

	_renderQuerySubjectItem() {
		const { module, model } = this.props;
		const shapingHelper = module.getShapingHelper();
		const mdColumn = module.getMetadataColumn(model.tooltipInfo.itemId);
		const moserColumn =  mdColumn ? mdColumn.moserObject : null;
		if (!moserColumn) { return null; }
		return (
			<shapingHelper.ShapingProvider>
				<ShapingAncestorTree
					includeParent={this.shapingAncestorTree_includeParent}
					moserObject={moserColumn}
				/>
			</shapingHelper.ShapingProvider>
		);
	}

	_closeToolTip = () => {
		this.props.model.showTooltip(null);
	}

	_renderDisambiguatedTooltip(tooltipInfo) {
		const tooltipLabel = StringResources.get('relationshipGraph_source_tooltip_label_title');
		return  (
			<Flyout
				domNodeToAttachTo={document.body}
				triggerNode={tooltipInfo.eventTarget}
				offset={10}
				placement={'bottomCentred'}
				candidatePlacement={['bottomCentred']}
				onClose={this._closeToolTip}
			>
				<div className="relationship-vis-view__disambiguatingTooltipTitle">{tooltipLabel}</div>
				<div className="relationship-vis-view__disambiguatingTooltip">{this._renderQuerySubjectItem()}</div>
			</Flyout>
		);
	}

	_shapingAncestorTree_includeParent = () => true

}
RelationshipTooltip.propTypes = {
	model: PropTypes.object.isRequired,
	module: PropTypes.object.isRequired,
	shouldUseDisambiguatedPaths: PropTypes.boolean
};


export default RelationshipTooltip;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipTooltip.js